import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import './DateRange.css'
import { IconCalendar } from "@tabler/icons-react";

const DateRange = ({ onApplyClick, date }) => {
  return (
    <div className="datepicker-section">
      <IconCalendar size={16} />
      <DateRangePicker initialSettings={{ startDate: date?.startDate || new Date(), endDate: date?.endDate || new Date(), opens: 'left' }} onApply={(e, p) => onApplyClick(p)} >
        <input type="text" className="bg-transparent focus:outline-none focus:border-none w-full" />
      </DateRangePicker>
    </div>
  );
}

export default DateRange;